import { Box, Card, CardHeader, Typography, useTheme } from "@mui/material";
import { CommentChat } from "components/comments/CommentChat";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { RecoReducerState,  
       } from "store/dataReducers/recommendationsSlice";
import { RootState } from "store/Store";
import { APIData } from "types/cms/frontendTypes";

export default function RecoComments() {

  const { id } = useParams()
  const theme = useTheme()
  const [reco, setReco] = useState<APIData<'api::recommendation.recommendation'>>()

  const draftRecos      = useSelector((state : RootState) => (state.recommendations as RecoReducerState).draftRecos)
  const publishedRecos  = useSelector((state : RootState) => (state.recommendations as RecoReducerState).publishedRecos)
  const modifiedRecos   = useSelector((state : RootState) => (state.recommendations as RecoReducerState).modifiedRecos)
 
  const memoizedRecos = useMemo(() => {
    const unModifiedPublishedRecos = publishedRecos.filter(
      pubReco => modifiedRecos.find(modReco => modReco.documentId === pubReco.documentId) === undefined)

    return [...draftRecos, ...modifiedRecos, ...unModifiedPublishedRecos]
  }, [draftRecos, modifiedRecos, publishedRecos])

  useEffect(() => {

    if (!id) return;
    const found = memoizedRecos.find(reco => reco.documentId === id);
    if (found) {
      setReco(found);
    }
  }, [id, memoizedRecos])

  return (

    <Box sx={{ width: '100%', height: '100%', overflow: 'auto', p: 2 }}>

    {
      reco ? (
        <Card sx={{ width: '100%', textAlign: 'left' }}>
          <CardHeader title={reco.recommendationId} />
          <div style={{ padding: '20px'}}>
              <div style={{ display: 'flex'}}>
                <img
                  style={{ width: 300, height: 'auto', objectFit: 'cover', 
                    backgroundColor: '#186cdd' }}
                  src={reco.fullImage?.url}
                  alt="fullImage"
                 />
                 <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography variant='h3' sx={{ fontWeight: 700, fontSize: '21px', 
                    paddingBottom: '15px', paddingLeft: '25px', paddingRight: '45px', lineHeight: '25.2px', color: 'inherit' }}>
                    {reco.title}
                  </Typography>
                  <Typography sx={{ paddingLeft: '25px', paddingRight: '45px', paddingBottom: '25px', color:  theme.palette.text.primary }}>
                    {reco.description}
                  </Typography>
                 </div>
              </div>
            </div>
        </Card>
      ) : (
        <Box>Loading...</Box>
      )
    }

    <Card sx={{ mt: 2 }}>
      <CommentChat 
        contentType={'api::recommendation.recommendation'}
        contentId={id!}
      />
    </Card>

    </Box>

  )
}